import { render, staticRenderFns } from "./wty-selectBox.vue?vue&type=template&id=3b060b17&scoped=true&"
import script from "./wty-selectBox.vue?vue&type=script&lang=js&"
export * from "./wty-selectBox.vue?vue&type=script&lang=js&"
import style0 from "./wty-selectBox.vue?vue&type=style&index=0&id=3b060b17&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b060b17",
  null
  
)

export default component.exports